import CommunicationCreate from "./communication-create";

export default CommunicationCreate;